<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default defineComponent({
//   created(){
// this.router.push('/en-US/walletPay')
//   },
  setup() {
      window.name = 'walletPay'
    // 路由守卫
    const router = useRouter();
    const i18n = useI18n();
    router.beforeEach((to, from, next) => {
      if(to.path==from.path) {
        next({ path: '/en-US/walletPay' })
      }else{
        next(); 
      }
      // 检查to.params.locale 是否存在，并设置相应的语言环境或执行其他逻辑
      const lang = to.params.lang;
      localStorage.setItem("language", lang || "en-US");
      i18n.locale.value = lang || "en-US";
      // 放这才能根据语言设title标签内容
    // 确保要调用next方法
    });

    router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/zh-CN') && !to.query.t && from.query.t) {
    // 如果切换语言时丢失了参数，自动带回来
    next({
      path: to.path,
      query: { ...to.query, t: from.query.t }
    })
  } else {
    next()
  }
})
  //   router.beforeEach((to, form, next) => {
  // if (to.path == form.path) {
  //   console.log(localStorage.getItem('language'));
    
  //   next({ path: '/en-US/walletPay' })
  // } else {
  //   next()
  // }

// })
  },
  
});
</script>
<style>
html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

:root body {
  position: absolute;
}

body {
  width: 100vw;
  overflow: hidden;

  margin: 0;
  padding: 0;

}

html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

:root body {
  position: absolute;
}

body {
  width: 100vw;
  overflow: hidden;
}
</style>